import React, {useEffect, useRef} from "react"
import * as d3 from "d3"
import * as Math from "mathjs"
import Box from '@material-ui/core/Box'

const Output1 = (props) => {
  const ref = useRef()
  useEffect(() => {

    let dimensions = {
      width: 900,
      height: 550,
      margin: {
        top: 20,
        right: 10,
        bottom: 50,
        left: 50
      }
    }

    dimensions.boundedWidth = dimensions.width - dimensions.margin.left - dimensions.margin.right
    dimensions.boundedHeight = dimensions.height - dimensions.margin.top - dimensions.margin.bottom

    const svgElement = d3.select(ref.current).attr("width", dimensions.width).attr("height", dimensions.height)

    svgElement.selectAll('*').remove()

    const bounds = svgElement.append("g").style("transform", `translate(${dimensions.margin.left}px, ${dimensions.margin.top}px)`)

    // Data Retrieve and process data => x*beta
    console.log(props.data)
    let {
      age,
      temperature,
      bmi,
      sex,
      ckd,
      sob,
      cancer,
      dm


    } = props.data

    // Process Data: Standardize & Age transformation
    age = (age-43.48) / 18.67
    temperature = (temperature - 37.05) / 0.5261
    bmi = (bmi-23.47) / 3.79
    // Calculate Coef and etc from R

    const coef0 = -3.2658
    const [coef1, coef2, coef3, coef4, coef5, coef6, coef7, coef8] =
    [
      1.5562,
      0.6429,
      0.2963,
      -0.6471,
      2.4304,
      1.9132,
      0.9282,
      0.3262
    ]
    const [ageMin, tempMin, bmiMin, sexMin, ckdMin, sobMin,cancerMin,dmMin] = [
      Math.min(coef1 * ((0-43.48) / 18.67), coef1 * ((97-43.48) / 18.67)),
      Math.min(coef2 * ((36.2 - 37.05) / 0.5261), coef2 * ((40 - 37.05) / 0.5261)),
      Math.min(coef3 * ((5.19-23.47) / 3.79), coef3 * ((66.79-23.47) / 3.79)),
      Math.min(coef4 * 0,coef4*1),
      Math.min(coef5*0,coef5*1),
      Math.min(coef6*0, coef6*1),
      Math.min(coef7*0, coef7*1),
      Math.min(coef8*0, coef8*1)
    ]
    // Max는 coef가 곱해진 값이다!!
    const [ageMax, tempMax, bmiMax, sexMax, ckdMax, sobMax,cancerMax,dmMax] = [
      Math.max(coef1 * ((0-43.48) / 18.67), coef1 * ((97-43.48) / 18.67)),
      Math.max(coef2 * ((36.2 - 37.05) / 0.5261), coef2 * ((40 - 37.05) / 0.5261)),
      Math.max(coef3 * ((5.19-23.47) / 3.79), coef3 * ((66.79-23.47) / 3.79)),
      Math.max(coef4*0,coef4*1),
      Math.max(coef5*0,coef5*1),
      Math.max(coef6*0, coef6*1),
      Math.max(coef7*0, coef7*1),
      Math.max(coef8*0, coef8*1)
    ]
    // Calculating
    const ageVal = age * coef1
    const tempVal = temperature * coef2
    const bmiVal = bmi * coef3
    const sexVal = sex * coef4
    const ckdVal = ckd * coef5
    const sobVal = sob * coef6
    const cancerVal = cancer * coef7
    const dmVal = dm * coef8


    const agePoint = ageVal - ageMin
    const tempPoint = tempVal - tempMin
    const bmiPoint = bmiVal - bmiMin
    const sexPoint = sexVal - sexMin
    const ckdPoint = ckdVal - ckdMin
    const sobPoint = sobVal - sobMin
    const cancerPoint = cancerVal - cancerMin
    const dmPoint = dmVal - dmMin

    const totalPoint = agePoint + tempPoint + bmiPoint + sexPoint + ckdPoint + sobPoint + cancerPoint + dmPoint
    const maxPoint = ageMax + tempMax + bmiMax + sexMax + ckdMax + sobMax + cancerMax + dmMax-(ageMin + tempMin + bmiMin + sexMin + ckdMin + sobMin + cancerMin + dmMin)
    const logit = coef0 +ageVal + tempVal + bmiVal + sexVal + ckdVal + sobVal + cancerVal + dmVal
    const prob = Math.exp(logit) / (Math.exp(logit) + 1)


    //  Bar Animation
    let i = d3.piecewise(d3.interpolateRgb.gamma(1), (["green", "#F5E772", "#E32D50"]))
    // TotalBar
    const totalWidth = 6
    const totalBar = bounds.append("g").attr("transform", "translate(200,400)")
    const totalBarScale = d3.scaleLinear().domain([0, 100]).range([
      0, totalWidth * 100
    ])
    const totalBarAxisGenerator = d3.axisBottom().scale(totalBarScale)
    const totalBarText = totalBar.append("text").text("Total Points").attr("font-weight", "bold").attr("text-anchor","start").attr("x",-240)
    const totalBarAxis = totalBar.append("g").call(totalBarAxisGenerator)
    const totalRect = totalBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", totalBarScale(100 * totalPoint / maxPoint)).attr("fill", i(totalPoint / maxPoint))
    const totalText = totalBar.append("text").transition().duration(1000).text(`${Math.round(100 * (totalPoint / maxPoint))}pt`).attr("x", totalBarScale(100 * (totalPoint / maxPoint)+1)).attr("font-size",14).attr("font-weight","bold")
    // ageBar

    const ageBar = bounds.append("g").attr("transform", "translate(200,0)")

    const ageBarScale = d3.scaleLinear().domain([
      0, 100 * (ageMax-ageMin) / maxPoint
    ]).range([
      0, 100 * (ageMax-ageMin) / maxPoint * totalWidth
    ])
    const ageBarAxisGenerator = d3.axisBottom().scale(ageBarScale).ticks(5)
    const ageBarText = ageBar.append("text").text("Age").attr("x",-240).attr("font-weight", "bold").attr("text-anchor","start")
    const ageBarAxis = ageBar.append("g").call(ageBarAxisGenerator)
    const ageRect = ageBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", ageBarScale(100 * (agePoint / maxPoint))).attr("fill", i(agePoint /(ageMax-ageMin)))
    const ageText = ageBar.append("text").transition().duration(1000).text(`${Math.round(100 * (agePoint / maxPoint))}pt`).attr("x", ageBarScale(100 * (agePoint / maxPoint)+1)).attr("font-size",14).attr("font-weight","bold")
    // temp bar
    const tempBar = bounds.append("g").attr("transform", "translate(200,50)")

    const tempBarScale = d3.scaleLinear().domain([
      0, 100 * (tempMax-tempMin) / maxPoint
    ]).range([
      0,
      (tempMax-tempMin) / maxPoint * totalWidth * 100
    ])
    const tempBarAxisGenerator = d3.axisBottom().scale(tempBarScale).ticks(5)
    const tempBarText = tempBar.append("text").text("Temperature").attr("text-anchor","start").attr("x",-240).attr("font-weight", "bold")
    const tempBarAxis = tempBar.append("g").call(tempBarAxisGenerator)
    const tempRect = tempBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", tempBarScale(100 * (tempPoint / maxPoint))).attr("fill", i(tempPoint / (tempMax-tempMin)))
    const tempText = tempBar.append("text").transition().duration(1000).text(`${Math.round(100 * (tempPoint / maxPoint))}pt`).attr("x", tempBarScale(100 * (tempPoint / maxPoint)+1)).attr("font-size",14).attr("font-weight","bold")
    // TempBar
    const bmiBar = bounds.append("g").attr("transform", "translate(200,100)")

    const bmiBarScale = d3.scaleLinear().domain([
      0, 100 * (((bmiMax-bmiMin) / maxPoint))
    ]).range([
      0,
      (((bmiMax-bmiMin) / maxPoint)) * totalWidth * 100
    ])
    const bmiBarAxisGenerator = d3.axisBottom().scale(bmiBarScale).ticks(5)
    const bmiBarText = bmiBar.append("text").text("BMI").attr("text-anchor","start").attr("x",-240).attr("font-weight", "bold")
    const bmiBarAxis = bmiBar.append("g").call(bmiBarAxisGenerator)
    const bmiRect = bmiBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", bmiBarScale(100 * (bmiPoint / maxPoint))).attr("fill", i(bmiPoint / (bmiMax-bmiMin)))
    const bmiText = bmiBar.append("text").transition().duration(1000).text(`${Math.round(100 * (bmiPoint / maxPoint))}pt`).attr("x", bmiBarScale(100 * (bmiPoint / maxPoint)+1)).attr("font-size",14).attr("font-weight","bold")
    // xray Bar
    const sexBar = bounds.append("g").attr("transform", "translate(200,150)")

    const sexBarScale = d3.scaleLinear().domain([
      0, 100 * (((sexMax-sexMin) / maxPoint))
    ]).range([
      0,
      (((sexMax-sexMin) / maxPoint)) * totalWidth * 100
    ])
    const sexBarAxisGenerator = d3.axisBottom().scale(sexBarScale).ticks(2)
    const sexBarText = sexBar.append("text").text("Sex").attr("text-anchor","start").attr("x",-240).attr("font-weight", "bold")
    const sexBarAxis = sexBar.append("g").call(sexBarAxisGenerator)
    const sexRect = sexBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", sexBarScale(100 * (sexPoint / maxPoint))).attr("fill", i(sexPoint / (sexMax-sexMin)))
    const sexText = sexBar.append("text").transition().duration(1000).text(`${Math.round(100 * (sexPoint / maxPoint))}pt`).attr("x", sexBarScale(100 * (sexPoint / maxPoint)+1)).attr("font-size",14).attr("font-weight","bold")

    // ckd Bar
    const ckdBar = bounds.append("g").attr("transform", "translate(200,200)")

    const ckdBarScale = d3.scaleLinear().domain([
      0, 100 * (((ckdMax-ckdMin) / maxPoint))
    ]).range([
      0,
      (((ckdMax-ckdMin) / maxPoint)) * totalWidth * 100
    ])
    const ckdBarAxisGenerator = d3.axisBottom().scale(ckdBarScale).ticks(3)
    const ckdBarText = ckdBar.append("text").text("Chronic kidney disorder").attr("text-anchor","start").attr("x",-240).attr("font-weight", "bold")
    const ckdBarAxis = ckdBar.append("g").call(ckdBarAxisGenerator)
    const ckdRect = ckdBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", ckdBarScale(100 * (ckdPoint / maxPoint))).attr("fill", i(ckdPoint / (ckdMax-ckdMin)))
    const ckdText = ckdBar.append("text").transition().duration(1000).text(`${Math.round(100 * (ckdPoint / maxPoint))}pt`).attr("x", ckdBarScale(100 * (ckdPoint / maxPoint)+1)).attr("font-size",14).attr("font-weight","bold")
    // sob
    const sobBar = bounds.append("g").attr("transform", "translate(200,250)")

    const sobBarScale = d3.scaleLinear().domain([
      0, 100 * (((sobMax-sobMin) / maxPoint))
    ]).range([
      0,
      (((sobMax-sobMin) / maxPoint)) * totalWidth * 100
    ])
    const sobBarAxisGenerator = d3.axisBottom().scale(sobBarScale).ticks(2)
    const sobBarText = sobBar.append("text").text("Shortness of breath").attr("text-anchor","start").attr("x",-240).attr("font-weight", "bold")
    const sobBarAxis = sobBar.append("g").call(sobBarAxisGenerator)
    const sobRect = sobBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", sobBarScale(100 * (sobPoint / maxPoint))).attr("fill", i(sobPoint / (sobMax-sobMin)))
    const sobText = sobBar.append("text").transition().duration(1000).text(`${Math.round(100 * (sobPoint / maxPoint))}pt`).attr("x", sobBarScale(100 * (sobPoint / maxPoint)+1)).attr("font-size",14).attr("font-weight","bold")

    const cancerBar = bounds.append("g").attr("transform", "translate(200,300)")

    const cancerBarScale = d3.scaleLinear().domain([
      0, 100 * (((cancerMax-cancerMin) / maxPoint))
    ]).range([
      0,
      (((cancerMax-cancerMin) / maxPoint)) * totalWidth * 100
    ])
    const cancerBarAxisGenerator = d3.axisBottom().scale(cancerBarScale).ticks(2)
    const cancerBarText = cancerBar.append("text").text("Cancer").attr("text-anchor","start").attr("x",-240).attr("font-weight", "bold")
    const cancerBarAxis = cancerBar.append("g").call(cancerBarAxisGenerator)
    const cancerRect = cancerBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", cancerBarScale(100 * (cancerPoint / maxPoint))).attr("fill", i(cancerPoint / (cancerMax-cancerMin)))
    const cancerText = cancerBar.append("text").transition().duration(1000).text(`${Math.round(100 * (cancerPoint / maxPoint))}pt`).attr("x", cancerBarScale(100 * (cancerPoint / maxPoint)+1)).attr("font-size",14).attr("font-weight","bold")


    const dmBar = bounds.append("g").attr("transform", "translate(200,350)")

    const dmBarScale = d3.scaleLinear().domain([
      0, 100 * (((dmMax-dmMin) / maxPoint))
    ]).range([
      0,
      (((dmMax-dmMin) / maxPoint)) * totalWidth * 100
    ])
    const dmBarAxisGenerator = d3.axisBottom().scale(dmBarScale).ticks(2)
    const dmBarText = dmBar.append("text").text("Diabetes").attr("text-anchor","start").attr("x",-240).attr("font-weight", "bold")
    const dmBarAxis = dmBar.append("g").call(dmBarAxisGenerator)
    const dmRect = dmBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", dmBarScale(100 * (dmPoint / maxPoint))).attr("fill", i(dmPoint / (dmMax-dmMin)))
    const dmText = dmBar.append("text").transition().duration(1000).text(`${Math.round(100 * (dmPoint / maxPoint))}pt`).attr("x", dmBarScale(100 * (dmPoint / maxPoint)+1)).attr("font-size",14).attr("font-weight","bold")



    // Prob Bar
    const probBar = bounds.append("g").attr("transform", "translate(200,450)")

    const probBarScale = d3.scaleLinear().domain([0, 1]).range([
      0, totalWidth * 100
    ])
    const probBarAxisGenerator = d3.axisBottom().scale(probBarScale)
    const probBarText = probBar.append("text").text("Probability").attr("text-anchor","start").attr("x",-240).attr("font-weight", "bold")
    const probBarAxis = probBar.append("g").call(probBarAxisGenerator)
    const probRect = probBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", probBarScale(prob)).attr("fill", i(prob))
    const probText = probBar.append("text").transition().duration(1000).text(`${Math.round(100 * prob)}%`).attr("x", probBarScale(prob)+5).attr("font-size",15).attr("font-weight","bold")

  }, [props.data])

  return (<Box border="3px solid gray">
    <svg ref={ref}/>
  </Box>)
}

export default Output1
